import { createSlice } from '@reduxjs/toolkit';

export const legendModes = {
  RECEIVED_VS_DEMAND: 'receivedVsDemand',
  HEAT_RECEIVED: 'heatReceived',
  HEAT_RECEIVED_MUNICIPALITY: 'heatReceivedMunicipality',
  HEAT_RECEIVED_STAT_SECTOR: 'heatReceivedStatSector',
};

const initialState = {
  legendMode: legendModes.RECEIVED_VS_DEMAND,
  heatReceivedMaximum: {
    [legendModes.HEAT_RECEIVED_MUNICIPALITY]: 700000000,
    [legendModes.HEAT_RECEIVED_STAT_SECTOR]: 40000000,
  },
  heatReceivedLegendMode: legendModes.HEAT_RECEIVED_MUNICIPALITY,
};

const consumers = createSlice({
  name: 'consumers',
  initialState,
  reducers: {
    setLegendMode: (state, action) => {
      state.legendMode = action.payload;
    },
    setHeatReceivedLegendMode: (state, action) => {
      state.heatReceivedLegendMode = action.payload;
    },
  },
});

export const {
  setHeatReceivedLegendMode,
  setLegendMode,
} = consumers.actions;
export default consumers.reducer;
